var s = window.s || {};

s.menu = {
	$holderMain: null,
	$holderMobile: null,
	agentID: null,
	initItemReplace: function (){
		if (s.tabletFix.is(':hidden') && s.mobileFix.is(':hidden')){
			$('#nav').appendTo(this.$holderMain);
		}
		if (s.tabletFix.is(':visible') && s.mobileFix.is(':hidden')){
			$('#nav').appendTo(this.$holderMobile.find(".mobile-nav-holder"));
		}
		if (s.tabletFix.is(':hidden') && s.mobileFix.is(':visible')){
			$('#nav').appendTo(this.$holderMobile.find(".mobile-nav-holder"));
		}
	},
	initMobileNavResize: function (){
		if (s.tabletFix.is(':hidden') && s.mobileFix.is(':hidden')){
			if (s.dom.$header.hasClass('nav-opened')){
				this.$holderMobile.hide();
				s.dom.$header.removeClass('nav-opened');
			}
		} else {
			if (this.agentID){
				this.$holderMobile.css({
					'height':'auto'
				});
				if (this.$holderMobile.outerHeight() > window.innerHeight){
					this.$holderMobile.height(window.innerHeight)
				}
			}
		}
	},
	initNavAccordionFix: function (){
		if (s.tabletFix.is(':hidden') && s.mobileFix.is(':hidden')){
			this.$holderMain.find("#nav .drop").attr("style", "");
			this.$holderMain.find("#nav .opened").removeClass("opened");
		}
	},
	mobileOpen: function(){
		var self = this;
		this.$holderMobile.slideDown(300, function(){
			s.dom.$header.addClass('nav-opened');
			s.dom.$html.addClass('popup-active');
			s.dom.$body.addClass('navmenu-active');
			self.$holderMobile.css({
				'height':'auto'
			});
			if(self.agentID){
				if(self.$holderMobile.outerHeight() > window.innerHeight){
					self.$holderMobile.height(window.innerHeight)
				}
			}
		});
	},
	mobileClose: function(){
		this.$holderMobile.slideUp(300, function(){
			s.dom.$header.removeClass('nav-opened');
			s.dom.$html.removeClass('popup-active');
			s.dom.$body.removeClass('navmenu-active');
		});
	},
	init: function(){
		var self = this;
		
		this.$holderMain = s.dom.$header.find(".desktop-nav-holder");
		this.$holderMobile = s.dom.$header.find(".mobile-nav");
		this.agentID = navigator.userAgent.toLowerCase().match(/(iphone|ipod|ipad|android)/i);
		
		this.initItemReplace = $.proxy(this.initItemReplace, this);
		this.initMobileNavResize = $.proxy(this.initMobileNavResize, this);
		this.initNavAccordionFix = $.proxy(this.initNavAccordionFix, this);
		this.mobileOpen = $.proxy(this.mobileOpen, this);
		this.mobileClose = $.proxy(this.mobileClose, this);
		
		this.initItemReplace();
		this.initMobileNavResize();
		this.initNavAccordionFix();
		s.dom.$window.resize(function(){
			self.initItemReplace();
			self.initMobileNavResize();
			self.initNavAccordionFix();
		});
		
		s.dom.$header.find(".nav-opener").on("click", function(e){
			e.preventDefault();
			if ( ! self.$holderMobile.is(':animated')){
				if (s.dom.$header.hasClass('nav-opened')){
					self.mobileClose();
				} else {
					self.mobileOpen();
				}
			}
		});
		
		s.dom.$body.on("click", function(e) {
			if (s.dom.$body.hasClass("navmenu-active")) {
				self.mobileClose();
			}
		});
		s.dom.$body.on('touchstart', function(event) {
			if (s.dom.$body.hasClass("navmenu-active")) {
				//self.mobileClose();
			}
		});
		this.$holderMobile.on("click", ".container", function(e){
			if (e.target.nodeName.toLowerCase() !== "a") {
				e.stopPropagation();
			}
		});
		
		s.dom.$header.on("click", "#nav .has-drop > a", function(e){
			e.stopPropagation();
			e.preventDefault();
			
			var $this = $(this);
			if ( ! self.$holderMobile.find(".drop").is(":animated")){
				$this.closest("li")
					.siblings().find(".drop")
						.slideUp(200);
				$this.closest("li")
					.siblings().find(".has-drop > a")
						.removeClass("opened");
				if ($this.hasClass("opened")){
					$this.closest("li").find(".drop").slideUp(200, function(){
						$this.removeClass("opened");
					});
				} else {
					$this.closest("li").find(".drop").slideDown(200, function(){
						$this.addClass("opened");
					});
				}
			}
		});
	}
};
